/**
 * @name setScrollHint.js
 */

class setScrollHint {
    constructor() {
        this.flag = document.querySelector('.js-scroll-hint');
        if (!this.flag) return;

        this.scrollHint = this.flag;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.__event();
    }

    /**
     * @name __event
     */
    __event() {
        this.scrollHint.addEventListener('scroll', () => {
            this.scrollHint.classList.add('isScrolling');
        }, { once: true });
    }
}

export default setScrollHint;